(function ($, njm) {
    'use strict';

    njm.views.verticalTabs = Backbone.View.extend({

        /**
         * Initialize
         */
        initialize: function () {
            this.$holder = this.$('.holder');

            // execute view and listener
            this.listenToMedia(this.render.bind(this));
            this.render(this.getCurrentMedia());
        },

        /**
         * Render
         * @param {string} media
         */
        render: function (media) {
			if (this.lastView) {
				
				if (this.lastView.medias.indexOf(media) === -1) {
					this.lastView.close();
					this.lastView = this.switchMedia(media);
				}
				
			} else {
				// append view based on media
            	this.lastView = this.switchMedia(media);
			}
			
			
            
        },

        /**
         * Switch View by media
         * @param media
         * @returns {Object}
         */
        switchMedia: function (media) {
            switch (media) {
                case 'mobile':
                    return this.renderMobile();

                case 'tablet':
				case 'desktop':
                    return this.renderDesktop();
            }
        },

        /**
         * Render Mobile
         * @returns {Object}
         */
        renderMobile: function () {
            return new njm.views.verticalTabsMobile({
                el: this.$holder,
				template: this.$('#comp-vertical-tabs-mobile-' + this.templateNum)
            });
        },

        /**
         * Render Desktop
         * @returns {Object}
         */
        renderDesktop: function () {
			
            return new njm.views.verticalTabsDesktop({
                el: this.$holder
            });
        }

    });
})(jQuery, njm);